<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">首页管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>平台通知</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回平台通知列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >

          <el-form-item
            label="标题"
            prop="title"
          >
            <el-input
              v-model="form.title"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="简介"
            prop="description"
          >
            <el-input
              v-model="form.description"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <UEditor
              :config=config
              ref="ueditor"
            ></UEditor>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </el-main>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
import UEditor from "@/components/ueditor.vue";
var _ = require("lodash");
export default {
  name: "addPlatNotice",
  components: { UEditor },
  data() {
    return {
      config: {
        //可以在此处定义工具栏的内容
        // toolbars: [
        //  ['fullscreen', 'undo', 'redo','|','bold', 'italic', 'underline',
        //  '|','superscript','subscript','|', 'insertorderedlist', 'insertunorderedlist',
        //  '|','fontfamily','fontsize','justifyleft','justifyright','justifycenter','justifyjustify']
        // ],
        autoHeightEnabled: false,
        autoFloatEnabled: true,
        initialContent: "请输入内容", //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
        autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
        initialFrameWidth: null,
        initialFrameHeight: 450,
        BaseUrl: "",
        UEDITOR_HOME_URL: "/static/ueditor/"
      },
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      good: null,
      wordName: "新增",
      addFormRule: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        description: [
          { required: true, message: "请输入简介", trigger: "blur" }
        ],
      },
      addLoading: false,
      form: {
        title: null,
        description: null,
        content: null,
        id: null
      }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    var good = this.$route.query.good;
    that.good = good;
    var para = {
      id: that.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    if (good != null) {
      that.wordName = "修改";
      that.form.id = good.id;
      that.form.title = good.title;
      that.form.description = good.description;
      that.$refs.ueditor.setContentInfo(good.content);
    } else {
      that.form.info_type = '1';
      that.wordName = "立即创建";
    }
  },
  computed: {},
  methods: {
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    backList() {
      this.$router.push({
        path: "/platNoticeList"
      });
    },

    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          let content = this.$refs.ueditor.getUEContent();
            para.content = content;
            if (
              para.content == null ||
              para.content == "" ||
              para.content == "<p>请输入内容</p>"
            ) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请填写文章",
                duration: 2000
              });
              return;
            }
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.add_up_plat_notice(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (para.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/addPlatNotice.vue